var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.patientData.isLoaded
    ? _c("PatientProfileModalSkeleton")
    : _c("div", [
        _c(
          "div",
          { staticClass: "text--text pa-4" },
          [
            _c("div", { staticClass: "text-subtitle-1 mb-6" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$i18next.t("Доверие к профилю", _vm.options)) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("PatientProfileTrustInfo", {
              staticClass: "mb-6",
              attrs: {
                "trust-percent": _vm.patientData.trust_percent,
                "can-trust": _vm.patientData.can_trust,
              },
            }),
            _vm._v(" "),
            _c("PatientProfileCriteria", {
              staticClass: "mb-10",
              attrs: { criteria: _vm.patientData.trust_criteria },
            }),
            _vm._v(" "),
            _c("PatinetProfileRatesStatistic", {
              staticClass: "mb-10",
              attrs: {
                "count-canceled": _vm.patientData.count_rates_canceled,
                "count-negative": _vm.patientData.count_rates_negative,
                "count-positive": _vm.patientData.count_rates_positive,
                "count-without-mark": _vm.patientData.count_rates_without_mark,
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-space-between text-subtitle-1 mb-6",
              },
              [
                _c("span", { staticClass: "mr-4" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$i18next.t("Записи на приём через", _vm.options)
                      ) +
                      " "
                  ),
                  _c("br"),
                  _vm._v(
                    " " +
                      _vm._s(_vm.isYDoc ? "YDoc" : "Продокторов") +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    attrs: { "data-qa": "patient_profile_count_appointments" },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.patientData.count_appointments ||
                            _vm.$i18next.t("Нет", _vm.options)
                        ) +
                        "\n      "
                    ),
                  ]
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class: [
              "b-btn-fixed b-btn-fixed_active patient-profile-modal__fixed-container",
              { "pa-2": _vm.btnFixedFloat },
            ],
          },
          [
            _c(
              "button",
              {
                class: [
                  "b-btn-fixed__control b-button b-button_blue patient-profile-modal__fixed-btn",
                  {
                    "patient-profile-modal__fixed-btn_float": _vm.btnFixedFloat,
                  },
                ],
                attrs: { "data-qa": _vm.dataQALocators.node_btn_close },
                on: { click: _vm.handleCloseModal },
              },
              [
                _c("span", { staticClass: "text-button" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$i18next.t("Закрыть", _vm.options)) +
                      "\n      "
                  ),
                ]),
              ]
            ),
          ]
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }